const axisColor = '#ccc';
const axisLabelColor = '#000';
export const TIME_AXIS = 'time-axis';
export const VALUE_AXIS = 'value-axis';
export const DOD_TIME_AXIS = 'dod-time-axis';
import { FONT_FAMILY } from '@utils/constants';
import moment from 'moment';

export const utcMoment = moment.utc;

const PRIMARY_SERIES = [
  {
    id: 'USAGE_METRIC_SERIES',
    type: 'line',
  },
];

const timeXAxis = {
  id: TIME_AXIS,
  type: 'category',
  show: true,
  splitNumber: 10,
  axisLabel: {
    color: axisLabelColor,
    fontSize: 12,
    fontFamily: FONT_FAMILY,
    hideOverlap: true,
    showMinLabel: true,
    showMaxLabel: true,
  },
  splitLine: {
    show: false,
  },
  axisTick: {
    alignWithLabel: false,
    lineStyle: {
      color: axisColor,
    },
  },
  axisLine: {
    show: true,
    lineStyle: {
      color: axisColor,
    },
  },
};
const valueYAxis = {
  id: VALUE_AXIS,
  type: 'value',
  show: true,
  splitNumber: 2,
  nameLocation: 'middle',
  axisLabel: {
    color: axisLabelColor,
    fontSize: 12,
    fontFamily: FONT_FAMILY,
    hideOverlap: true,
    showMinLabel: true,
    showMaxLabel: true,
  },
  splitLine: {
    show: true,
  },
  axisTick: {
    show: false,
  },
  axisLine: {
    show: false,
    lineStyle: {
      color: axisColor,
    },
  },
};
export const chartOption = (metric) => {
  return {
    id: metric,
    xAxis: [timeXAxis],
    yAxis: [valueYAxis],
    grid: {
      top: 20,
      bottom: 35,
      left: 50,
      right: 35,
    },
    series: [...PRIMARY_SERIES],
    tooltip: {
      trigger: 'axis',
      textStyle: { fontFamily: FONT_FAMILY, fontSize: 12 },
      confine: true,
      appendToBody: true,
      className: 'echarts-tooltip',
    },
    dataZoom: [
      {
        type: 'slider',
        show: false,
        xAxisIndex: [0],
      },
      {
        type: 'slider',
        show: false,
        xAxisIndex: 1,
      },
    ],
    toolbox: {
      show: false,
    },
    brush: {
      brushType: 'lineX',
      seriesIndex: [0],
      brushLink: [0],
      xAxisIndex: [0],
      transformable: false,
      throttleType: 'debounce',
      throttleDelay: 300,
      brushStyle: {
        borderWidth: 1,
        color: 'rgba(120,140,180,0.3)',
        borderColor: 'rgb(224, 224, 224,0.8)',
      },
    },
    legend: {
      show: false,
      type: 'scroll',
    },
    animation: true,
    _metric: metric,
    _title: 'metricInfo.displayName',
    _shortMetric: 'metricInfo.short',
    _subscript: 'metricInfo.subscript',
    _unit: 's',
    _viewType: 'timeseries',
  };
};
